import { fireUtagEvent } from '@garmin/support-analytics';

class DetailsAnalytics {
  constructor() {
    this.category = 'ORMA Product ID';
  }

  triggerValidOrderSubmissionAnalytics(verificationResponse) {
    const ibProductName = verificationResponse?.rmaInboundProductDetails?.pvName;
    const obProductName = verificationResponse?.rmaOutboundProductDetail?.pvName;
    const obIbLabel = `Inbound: ${ibProductName} / Outbound: ${obProductName}`;

    this.triggerAnalyticsEvent({
      event_category: this.category,
      event_action: 'Outbound Product',
      event_label: obProductName,
    });
    this.triggerAnalyticsEvent({
      event_category: this.category,
      event_action: 'Inbound Product',
      event_label: ibProductName,
    });

    this.triggerAnalyticsEvent({
      event_category: 'ORMA Cart',
      event_action: 'Inbound/Outbound Product',
      event_label: obIbLabel,
    });
    this.triggerAnalyticsEvent({
      event_category: 'ORMA Cart',
      event_action: 'Link',
      event_label: 'Submit',
    });
  }

  triggerInvalidOrderSubmissionAnalytics(label = '') {
    this.triggerAnalyticsEvent({
      event_category: 'ORMA Exception',
      event_action: 'Exception',
      event_label: label,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  triggerAnalyticsEvent(manualAnalyticsEvent) {
    fireUtagEvent(manualAnalyticsEvent);
  }
}

export default DetailsAnalytics;
